import { axiosInstance } from './instance';

const getCouponsService = (storeId, page = 0, limit = 20) => {
    return axiosInstance.get(`/stores/${storeId}/coupons`, {
        params: {
            page,
            limit,
        },
    });
};

const getCouponService = (storeId, couponId) => {
    return axiosInstance.get(`/stores/${storeId}/coupons/${couponId}`);
};

const createCouponService = (storeId, data) => {
    return axiosInstance.post(`/stores/${storeId}/coupons`, data);
};

const updateCouponService = (storeId, couponId, data) => {
    return axiosInstance.put(`/stores/${storeId}/coupons/${couponId}`, data);
};

const deleteCouponService = (storeId, couponId) => {
    return axiosInstance.delete(`/stores/${storeId}/coupons/${couponId}`);
};

const getCouponUsageService = (storeId, couponId, page = 0, limit = 20) => {
    return axiosInstance.get(`/stores/${storeId}/coupons/${couponId}/usage`, {
        params: {
            page,
            limit,
        },
    });
};

const validateCouponPublicService = (storeId, data) => {
    return axiosInstance.post(`/api/v1/wa10x/stores/${storeId}/coupons/validate`, data);
};

export {
    getCouponsService,
    getCouponService,
    createCouponService,
    updateCouponService,
    deleteCouponService,
    getCouponUsageService,
    validateCouponPublicService,
};

